import { Button, Clickable, Col, H2, Row, SpacerWrapper } from '@ahmdigital/ui';
import { isEmpty, map } from 'lodash/fp';
import Icon from '@ahmdigital/icons-web';
import styled, { css } from 'styled-components';

import { scrollToElement } from '../../../../utils/ui';
import type { Tree } from '../decision-tree/utils/get-branch';

export const focusVisible = css`
  :focus-visible {
    outline: 2px dotted ${({ theme }) => theme.colors.grey50};
    outline-offset: 3px;
  }
`;

const DecisionButton = styled(Button)`
  margin: 0.5rem;
  padding: 0.75rem 1.25rem;
  max-width: max-content;

  ${({ theme }) => css`
    ${theme.mediaQueries.above(theme.media.sm)} {
      padding: 1rem 1.5rem;
      font-size: 20px;
    }
  `}
`;

const BranchHeading = styled(H2)`
  margin: 2.5rem 0 0.75rem;

  ${({ theme }) => css`
    ${theme.mediaQueries.above(theme.media.sm)} {
      margin: 5rem 0 1.75rem;
    }
  `}

  ${focusVisible}
`;

const IconContainer = styled.div`
  margin-top: 2.875rem;

  ${({ theme }) => css`
    ${theme.mediaQueries.above(theme.media.sm)} {
      margin-top: 5.5rem;
    }
  `}
`;

type Props<T extends string> = Readonly<{
  branchHeading?: string;
  selected?: Tree<T>;
  branches?: ReadonlyArray<Tree<T>>;
  onSelect: (selected: T, onSelect?: string) => void;
}>;

export const firstRowId: string = 'firstRow';

// @ts-expect-error - Automatic, Please fix when editing this file
const Branch = <T extends string>({ onSelect, selected = null, branches = null, branchHeading = null }: Props<T>) => {
  // @ts-expect-error - Automatic, Please fix when editing this file
  const decisionButtonHandler = (item: T | null, content?) => () => {
    // @ts-expect-error - Automatic, Please fix when editing this file
    onSelect(item, content);
  };
  const arrowOnClickHandler = () => {
    scrollToElement(document.getElementById(firstRowId));
  };

  return (
    <SpacerWrapper>
      {branchHeading && (
        <Row lgHorizontalAlign="center">
          {/* @ts-expect-error [🤖 PLEASE FIX 🤖]: No overload matches this call. */}
          <BranchHeading looksLike="h4" id={branchHeading} tabIndex="0">
            {branchHeading}
          </BranchHeading>
        </Row>
      )}
      <Row lgHorizontalAlign="center">
        <Col md={12} df={6}>
          {!isEmpty(branches) ? (
            <Row lgHorizontalAlign="center">
              {selected ? (
                <DecisionButton
                  onClick={decisionButtonHandler(null)}
                  variant={['purple', 'rounded', 'thinBorder', 'purpleHover']}
                >
                  {selected.content.title}
                </DecisionButton>
              ) : (
                <>
                  {map(
                    ({ content, id }) => (
                      <DecisionButton
                        key={id}
                        onClick={decisionButtonHandler(id, content)}
                        variant={['border', 'transparentBlack', 'rounded', 'thinBorder', 'shadowHover']}
                      >
                        {content.title}
                      </DecisionButton>
                    ),
                    branches,
                  )}
                </>
              )}
            </Row>
          ) : (
            <Row lgHorizontalAlign="center">
              <IconContainer>
                <Clickable aria-label="Scroll down" isUnstyled onClick={arrowOnClickHandler}>
                  <Icon name="arrow-down" width={24} height={24} />
                </Clickable>
              </IconContainer>
            </Row>
          )}
        </Col>
      </Row>
    </SpacerWrapper>
  );
};

export default Branch;
